export default "__VITE_ASSET__DEhDaOGm__"